<template>
  <modal
      name="ExcludedCascadeAccess"
      :confirm="$t('button.save')"
      :title="action === 'create' ?
      $t('cascade_access.create_non_overridden_accesses') :
      $t('cascade_access.update_non_overridden_access')"
      :preventHideOnOk="true"
      @ok="okButtonPressed"
      @hidden="clearCascadeAccessData"
  >
    <template slot="body">
      <b-row>
        <b-col md="12">
          <group-select :input="resourceInputConfig"
                        :model="modelResource"
                        :groupSelect="false"
                        @select="onSelectResource"
                        @remove="onSelectResource"
                        valueKey="key"
                        :disabledItems="usedResources"
          >
          </group-select>
        </b-col>

        <b-col md="12" class="mt-4">
          <group-select :input="typeInputConfig"
                        :model="modelType"
                        :groupSelect="false"
                        :disabled="true"
                        @select="onSelectType"
                        @remove="onSelectType"
          >
          </group-select>
        </b-col>

        <b-col md="12">
          <group-select class="mt-4"
                        :key="selectedResource"
                        :model="modelSource"
                        v-if="selectedResource && selectedType === 'type_subscription'"
                        :input="planInputConfig"
                        :requestHeaders="headers"
                        @select="onSelectSource"
                        @remove="onSelectSource"
          >
          </group-select>
        </b-col>

        <b-col md="12">
          <group-select class="mt-4"
                        :key="selectedResource"
                        :model="modelSource"
                        v-if="selectedResource && selectedType === 'type_ticket'"
                        :input="eventInputConfig"
                        :requestHeaders="headers"
                        @select="onSelectSource"
                        @remove="onSelectSource"
          >
          </group-select>
        </b-col>

        <b-col md="12">
          <group-select class="mt-4"
                        :key="selectedResource"
                        :model="modelSource"
                        v-if="selectedResource && selectedType === 'type_content'"
                        :input="contentInputConfig"
                        :requestHeaders="headers"
                        :groupSelect="false"
                        @select="onSelectSource"
                        @remove="onSelectSource"
          >
          </group-select>
        </b-col>

        <b-col md="12" class="mt-4">
          <label :for="activeInputConfig.name">{{ activeInputConfig.label }}
            <span class="text-danger">
              {{ $t('form.required_star') }}
            </span>
          </label>
          <div class="d-flex flex-row input-height align-items-center">
            <label class="switch switch-3d switch-success mb-0">
              <b-form-checkbox type="checkbox"
                               class="switch-input"
                               v-model="selectedActive"
              />
              <input type="checkbox"
                     class="switch-input"
                     :checked="selectedActive"
              >
              <span class="switch-slider"></span>
            </label>
          </div>
        </b-col>

      </b-row>
    </template>
  </modal>
</template>
<script>

import i18n from "@/utils/i18n";
import GroupSelect from "@/components/global/groupSelect";
import {get, isNull, find} from "lodash";

const typeOptions = [
  {label: i18n.t('cascade_access.type_subscription'), value: "type_subscription"},
  {label: i18n.t('cascade_access.type_ticket'), value: "type_ticket"},
  {label: i18n.t('cascade_access.type_content'), value: "type_content"},
]

export default {
  name: "ExcludedCascadeAccessModal",
  props: {
    partnerId: {
      type: Number,
      required: true
    },
    usedResources: {
      type: Array,
      required: true
    },
    cascadeAccessId: {
      type: Number,
      required: true
    },
    excludedAccessItem: {
      type: Object,
      default: () => null
    },
    action: {
      type: String,
      default: 'create'
    },
    onCancelCallback: {
      type: Function,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  components: {
    GroupSelect
  },
  data() {
    return {
      resourceInputConfig: {
        name: "cascadeAccessResource",
        type: "select",
        required: true,
        allowEmpty: false,
        multiple: false,
        group: false,
        label: i18n.t('cascade_access.resource'),
        placeholder: i18n.t('cascade_access.please_select'),
        options_url: "partner/resources",
      },
      typeInputConfig: {
        name: "cascadeAccessType",
        type: "select",
        required: true,
        allowEmpty: false,
        multiple: false,
        group: false,
        options: typeOptions,
        label: i18n.t('cascade_access.type'),
      },
      planInputConfig: {
        name: "cascadeAccessPlan",
        type: "select",
        label: i18n.t('form.subscription'),
        placeholder: i18n.t('cascade_access.please_select'),
        required: true,
        searchable: true,
        multiple: false,
        assembleValues: true,
        filter_field: 'title',
        options_url: "plans?limit=100",
      },
      eventInputConfig: {
        name: "cascadeAccessEvent",
        type: "select",
        label: i18n.t('form.event'),
        placeholder: i18n.t('cascade_access.please_select'),
        required: true,
        searchable: true,
        multiple: false,
        assembleValues: true,
        filter_field: 'title',
        items_key: "tickets",
        options_url: "ti-events?limit=100",
      },
      contentInputConfig: {
        name: "cascadeAccessContent",
        type: "select",
        required: true,
        allowEmpty: false,
        multiple: false,
        label: i18n.t('form.contents'),
        placeholder: i18n.t('cascade_access.please_select'),
        options_url: "content?limit=100",
      },
      activeInputConfig: {
        label: i18n.t('form.active'),
        placeholder: i18n.t('form.active'),
        name: 'cascadeAccessActive'
      },
      selectedResource: null,
      modelResource: null,
      selectedType: null,
      modelType: null,
      selectedSubscription: null,
      selectedTicket: null,
      selectedContent: null,
      selectedSource: null,
      modelSource: null,
      selectedActive: true,
      headers: null
    }
  },
  created() {
    this.prefillType();
    if (this.action === 'update' && this.excludedAccessItem) {
      this.prefillResource();
      this.prefillSource();
      this.prefillActive();
    }
  },
  mounted() {

  },
  methods: {
    prefillType() {
      this.modelType = find(typeOptions, {value: this.type});
      this.selectedType = this.type;
    },

    prefillResource() {
      const resource = get(this.excludedAccessItem, "rawData.resource", null);
      if (resource) {
        this.modelResource = {
          label: resource.title,
          value: resource.key,
        }
        this.selectedResource = resource.key;
        this.headers = {'resource': resource.key};
      }
    },

    prefillSource() {
      const subscription = get(this.excludedAccessItem, "rawData.subscription", null);
      if (subscription) {
        this.modelSource = {
          label: subscription.title,
          value: subscription.id,
        }
        this.selectedSource = {
          "subscription_id": subscription.id
        }
      }
      const ticket = get(this.excludedAccessItem, "rawData.ti_event_ticket", null);
      if (ticket) {
        this.modelSource = {
          label: ticket.title,
          value: ticket.id,
        }
        this.selectedSource = {
          "ti_event_ticket_id": ticket.id
        }
      }
      const content = get(this.excludedAccessItem, "rawData.content", null);
      if (content) {
        this.modelSource = {
          label: content.title,
          value: content.id,
        }
        this.selectedSource = {
          "content_id": content.id
        }
      }
    },

    prefillActive() {
      const active = get(this.excludedAccessItem, "rawData.active", null);
      if (!isNull(active)) {
        this.selectedActive = active;
      }
    },

    okButtonPressed() {
      if (isNull(this.selectedSource)) {
        return this.$noty.error(i18n.t('cascade_access.fil_in_all_required_fields'));
      }
      if (this.action === 'create') {
        this.createExcludedCascadeAccess();
      } else {
        this.updateExcludedCascadeAccess();
      }
    },
    createExcludedCascadeAccess() {
      this.selectedSource["active"] = this.selectedActive;
      this.loading = true
      this.postData(`partners/${this.partnerId}/cascade-access/${this.cascadeAccessId}/exclude`,
          {...this.selectedSource})
          .then(() => {
            this.$bus.$emit(`reloadExcludedCascadeAccesses-${this.cascadeAccessId}`);
            this.$bus.$emit('closeExcludedCascadeAccessModal');
          })
          .catch(error => {
            if (error && error.response) {
              this.$noty.error(error.response.data.error_description);
            }
          })
          .finally(() => this.loading = false)
    },
    updateExcludedCascadeAccess() {
      this.selectedSource["active"] = this.selectedActive;
      this.loading = true;
      this.putData(`partners/${this.partnerId}/cascade-access/exclude/${this.excludedAccessItem.id}`,
          {...this.selectedSource})
          .then(() => {
            this.$bus.$emit(`reloadExcludedCascadeAccesses-${this.cascadeAccessId}`);
            this.$bus.$emit('closeExcludedCascadeAccessModal');
          })
          .catch(error => {
            if (error && error.response) {
              this.$noty.error(error.response.data.error_description);
            }
          })
          .finally(() => this.loading = false);
    },
    getCascadeAccessType(item) {
      if (item.subscription_id) return i18n.t('cascade_access.type_subscription');
      if (item.ti_event_ticket_id) return i18n.t('cascade_access.type_ticket');
      if (item.content_id) return i18n.t('cascade_access.type_content');
    },
    clearCascadeAccessData() {
      this.selectedResource = null;
      this.selectedType = null;
      this.selectedActive = false;
      this.modelResource = null;
      this.modelType = null;
      this.modelSource = null;
      this.clearCascadeAccessSourceData();
      this.onCancelCallback();
      this.$forceUpdate();
    },
    clearCascadeAccessSourceData() {
      this.selectedSource = null;
      this.selectedSubscription = null;
      this.selectedTicket = null;
      this.selectedContent = null;
      this.modelSource = null;
    },
    onSelectResource(obj) {
      this.selectedResource = get(obj, "value.value", null);
      this.clearCascadeAccessSourceData();
      this.headers = {'resource': this.selectedResource};
    },
    onSelectType(obj) {
      this.selectedType = get(obj, "value.value", null);
      this.clearCascadeAccessSourceData();
    },
    onSelectSource(source) {
      switch (this.selectedType) {
        case "type_subscription":
          this.selectedSource = {
            "subscription_id": get(source, "value.value", null)
          }
          break;
        case "type_ticket":
          this.selectedSource = {
            "ti_event_ticket_id": get(source, "value.value", null)
          }
          break;
        case "type_content":
          this.selectedSource = {
            "content_id": get(source, "value.value", null)
          }
          break;
      }
    },
  }
}
</script>
